import React from 'react';
import { Typography, Box, CardHeader, makeStyles } from '@material-ui/core';
import { useStoreActions } from 'easy-peasy';
import imgParams from '../../utils/imageUtil';
import AdapterLink from '../common/adapterLink';
import OptionsMenu from './optionsMenu';
import PostAuthorInfo from './postAuthorInfo';
import { ReactComponent as ChampionIcon } from '../../img/championIcon.svg';
import { isAdminOrModerator } from '../../utils/userUtil';
import AnyLink from '../common/anyLink';
import { imageUrls } from '../../utils/constants';

const PostHeader = ({
  post,
  isPostDetail,
  showOptions,
  postId,
  history,
  user,
}) => {
  const classes = useStyles();

  const setScrollPostId = useStoreActions(
    (actions) => actions.feed.setScrollPostId
  );

  function handleClick(e) {
    e && e.stopPropagation();
    if (!isPostDetail) {
      setScrollPostId(post.id);
    }
  }
  const pathname = window.location.pathname;
  function handleClickOnCommunity(e) {
    e && e.stopPropagation();
    // for community tracking
    history.push(post.communitySlug, {
      community_tracking_url: pathname,
      slug: post.slug,
    });
  }

  function handleProfileImage() {
    if (isAdminOrModerator()) {
      return post.userDeepLinkUrlForAdmin;
    } else {
      return post.userDeepLinkUrl || '';
    }
  }
  return (
    <React.Fragment>
      {post && post.metaInfo && (
        <Box alignItems="center" display="flex" ml={4}>
          {post.metaInfo.image && (
            <img
              width="10px"
              height="10px"
              src={post.metaInfo.image}
              alt="suggested"
            />
          )}
          <Box ml={1}>
            <Typography
              className={classes.metaInfo}
              dangerouslySetInnerHTML={{
                __html: post.metaInfo.text,
              }}
              component="span"
              variant="caption"
            />
          </Box>
        </Box>
      )}

      <CardHeader
        avatar={
          <Box display="inline-block" position="relative">
            <AnyLink to={handleProfileImage()}>
              <img
                className={classes.imgSet}
                component={
                  post && post.author && post.author.name === 'Anonymous'
                    ? 'span'
                    : AdapterLink
                }
                alt="avatar"
                src={imgParams(
                  (post.author && post.author.imageUrl) ||
                    imageUrls.DEFAULT_USER_IMG,
                  40,
                  40,
                  'auto'
                )}
              />
            </AnyLink>
            {post.isAuthorMentor && (
              <ChampionIcon className="championIconStyle" />
            )}
            {post.profileBadgeUrl && post.showProfileBadge && (
              <img
                className="postShareIcon"
                src={post.profileBadgeUrl}
                alt="she badge"
              />
            )}
          </Box>
        }
        action={
          showOptions && (
            <OptionsMenu
              post={post}
              isPostDetail={isPostDetail}
              postId={postId}
              fromHeader={true}
              user={user}
            />
          )
        }
        title={
          <PostAuthorInfo
            handleClick={handleClick}
            isPostDetail={isPostDetail}
            handleClickOnCommunity={handleClickOnCommunity}
            post={post}
          />
        }
        subheader={
          <Box display="inline-block">
            {isAdminOrModerator() && post.isAuthorProfileSpam && (
              <Typography
                className={classes.userSpamProfile}
                component="span"
                variant="caption"
              >
                Spam Profile
              </Typography>
            )}
          </Box>
        }
      />
    </React.Fragment>
  );
};

const useStyles = makeStyles({
  imgSet: {
    borderRadius: '12px',
  },
  metaInfo: {
    '& font': {
      fontFamily: 'inherit!important',
      fontWeight: '400!important',
    },
  },
  userSpamProfile: {
    border: '2px solid #f00',
    borderRadius: '10%',
    padding: '0px 4px',
    background: 'red',
    color: '#fff',
    marginTop: '4px',
    marginLeft: '2px',
    fontWeight: 'bold',
    display: 'inline-block',
  },
});

export default PostHeader;
